import * as queryRemoteTiles from '@/lib/queryRemoteTiles';

const QUERYZOOM = 15;
async function getBoundaryForPointNoLookup(stage, year, lngLatStr) {
    const lngLat = lngLatStr.map((x) => +x);

    const tilesetId = `catchments-${year}-${stage}`;

    const result = await queryRemoteTiles.queryLngLat(
        `${window.app.tileHost}/tiles/${tilesetId}/{z}/{x}/{y}.pbf`,
        lngLat,
        QUERYZOOM,
        'catchments',
        { quiet: window.location.hostname !== 'localhost' }
    );
    if (result && result.features && result.features.length) {
        return result.features[0].properties;
    } else {
        // console.log(`No boundary for ${stage} ${year} ${lngLat}`);
    }
}

async function getBoundariesForPointNoLookup(stage, years, lngLat) {
    const results = await Promise.all(
        years.map((year) => getBoundaryForPoint(stage, year, lngLat))
    );
    return results;
}

async function getBoundaryForPointLookup(stage, year, lngLat) {
    try {
        const response = await window
            .fetch(`${window.app.lookupHost}/lookup/${stage}/${year}/${lngLat}`)
            .then((response) => response.json());
        return response.result;
    } catch (e) {
        console.error(
            'Error looking up boundary for point',
            stage,
            year,
            lngLat
        );
        console.error(e);
    }
}

async function getBoundariesForPointLookup(stage, years, lngLat) {
    try {
        const response = await window
            .fetch(
                `${window.app.lookupHost}/multi-lookup/${stage}/${years}/${lngLat}`
            )
            .then((response) => response.json());
        return response.results;
    } catch (e) {
        console.error(
            'Error looking up boundaries for point',
            stage,
            years,
            lngLat
        );
        console.error(e);
    }
}

const mode = (window.location + '').match(/uselookup/) ? 'Lookup' : 'NoLookup';

export function getBoundaryForPoint(...args) {
    return mode === 'NoLookup'
        ? getBoundaryForPointNoLookup(...args)
        : getBoundaryForPointLookup(...args);
}

export function getBoundariesForPoint(...args) {
    return mode === 'NoLookup'
        ? getBoundariesForPointNoLookup(...args)
        : getBoundariesForPointLookup(...args);
}
